import { getDrawDates } from '@lotta/shared/util-draws';
import { DateTime } from 'luxon';
import type { Control } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { DrawDatesTable } from '../../../components/draw-dates-table/DrawDatesTable';
import type { MonthlyOccurrenceFormType } from '../MonthlyOccurrenceForm';
import { toPayload } from '../to-payload';

export const MonthlyDrawDaysPreview: React.FC<{
  control: Control<MonthlyOccurrenceFormType>;
  timezone: string;
}> = ({ control, timezone }) => {
  const startDate = useWatch({ control, name: 'startDate' });
  const endDate = useWatch({ control, name: 'endDate' });
  const drawDay = useWatch({ control, name: 'drawDay' });
  const drawTime = useWatch({ control, name: 'drawTime' });

  const parsedStartDate = DateTime.fromISO(startDate, { zone: timezone });
  const parsedEndDate = DateTime.fromISO(endDate, { zone: timezone });

  if (
    !parsedStartDate.isValid ||
    !parsedEndDate.isValid ||
    drawDay > 28 ||
    drawDay < 1 ||
    drawTime === ''
  ) {
    return null;
  }

  // Convert the user input to lottery schema format
  const { lottery } = toPayload({ startDate, endDate, drawDay, drawTime });

  const drawDates = getDrawDates(lottery, timezone);

  return <DrawDatesTable data={drawDates} />;
};
